var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-timer"},[_c('span',{staticClass:"base-timer__label",class:{ 'base-timer__run': _vm.run }},[_vm._v("\n    "+_vm._s(_vm._f("asMmSs")(_vm.timeLeft))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }